<template>
  <div v-loading="loading">
    <div v-if="radishData.length == 0">暂无数据</div>
    <div v-for="(radish, k) in radishData" :key="k"
      style="padding:10px;border:1px solid #ccc;border-radius:4px;margin-bottom:10px">
      <div style="display:flex;margin-bottom:5px">
        <div class="radish-link" @click="showRadish(radish._id)" style="margin-right:10px">{{name(radish.姓名)}}</div>
        <div v-if="companyName && radish.职能模块 && radish.职能模块.length > 0">
          <el-tag v-for="zhi in radish.职能模块" size="mini" :key="zhi" style="margin-right:5px">{{zhi}}</el-tag>
        </div>
        <div v-else-if="category && radish.公司">
          <el-tag size="mini">{{radish.公司}}</el-tag>
        </div>
        <div v-if="radish.职级" style="margin-left:5px"><el-tag size="mini">{{zhiMap[radish.职级]}}</el-tag></div>
        <div v-if="radish.专业职级" style="margin-left:5px"><el-tag size="mini">{{radish.专业职级}}</el-tag></div>
      </div>
      <div style="display:flex;justify-content:space-around;">
        <div>月固薪(万): {{money(radish.月固薪)}}</div>
        <div>年固薪(万): {{money(radish.年固薪)}}</div>
        <div>奖金(万): {{money(radish.奖金)}}</div>
        <div>全薪(万): {{radish.奖金?money(radish.全薪):'--'}}</div>
      </div>
    </div>
    <div v-if="showMore" style="text-align:center;margin-botton:10px">
      <el-button type="text" @click="next">加载更多</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    companyName: String,
    category: String,
    hangye: String,
    xi: String,
  },
  data() {
    return {
      radishData: [],
      page: 1,
      limit: 300,
      showMore: false,
      zhiMap: {
        '1': '1.高管',
        '2': '2.部门总',
        '3': '3.部门副总/总助/团队长',
        '4': '4.部门核心骨干',
        '5': '5.新人三年以下',
      },
      loading: false
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      if (!this.companyName && !this.category) {
        this.radishData = []
        return false
      }
      const query = {}
      if (this.companyName) query.公司 = this.companyName
      if (this.category) query.职能模块 = this.category
      if (this.hangye) query.行业 = this.hangye
      if (this.xi) query.细分职能 = this.xi
      const res = await app.service('radish').getRadishesMoney({query, limit: this.limit, skip: this.limit*(this.page - 1)})
      // console.log(query,this.page, res)
      if (res.status == 'success') {
        if (res.data.length == 0) {
          this.radishData = []
          this.showMore = false
        } else {
          const radishData = res.data.filter(dt=>{
            return !((!dt.月固薪 || isNaN(dt.月固薪)) && (!dt.年固薪 || isNaN(dt.年固薪)) && (!dt.奖金 || isNaN(dt.奖金)) && (!dt.全薪 || isNaN(dt.全薪)))
          })
          if (this.page > 1) {
            this.radishData = this.radishData.concat(radishData)
          } else {
            this.radishData = radishData
          }
          this.showMore = true
        }
      }
      this.loading = false
    },
    next() {
      this.page = this.page + 1
      this.loadData()
    },
    name(n) {
      return n.substr(0, 1)+'**'
    },
    money(m) {
      if (!m || isNaN(m)) return '--'
      return m
    },
    showRadish(id) {
      window.open(`${window.frontend}/#/radish-detail-blank/${id}`, '_blank')
    },
  }
}
</script>
